import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getRequest } from '../../../../helpers/axiosClient';
import actions from './actions';

export function* getPincodeDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.PINCODE_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.PINCODE_DETAILS_FAILURE, message: error?.response?.data });
        return error;
    }
}

export function* getAreaDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.AREA_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.AREA_DETAILS_FAILURE, message: error?.response?.data });
        return error;
    }
}

export function* getCityDetails(params) {

    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.CITY_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.CITY_DETAILS_FAILURE, message: error?.response?.data });
        return error;
    }
}

export function* getStateDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.STATE_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.STATE_DETAILS_FAILURE, message: error?.response?.data });
        return error;
    }
}

export function* getCountryDetails(params) {

    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.COUNTRY_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.COUNTRY_DETAILS_FAILURE, message: error?.response?.data });
        return error;
    }
}

export function* getLanguageDetails(params) {

    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest('language?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest('language'));
        }
        yield put({
            type: actions.LANGUAGE_DETAILS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({ type: actions.LANGUAGE_DETAILS_FAILURE, message: error?.response?.data });
        return error;
    }
}

export function* getClearDetails() {
    yield put({
        type: actions.CLEAR_ADDRESS_DETAILS_SUCCESS,
    });
}

export default function* addressSaga() {
    yield all([
        takeEvery(actions.AREA_DETAILS_START, getAreaDetails),
        takeEvery(actions.PINCODE_DETAILS_START, getPincodeDetails),
        takeEvery(actions.CITY_DETAILS_START, getCityDetails),
        takeEvery(actions.STATE_DETAILS_START, getStateDetails),
        takeEvery(actions.COUNTRY_DETAILS_START, getCountryDetails),
        takeEvery(actions.LANGUAGE_DETAILS_START, getLanguageDetails),
        takeEvery(actions.CLEAR_ADDRESS_DETAILS_START, getClearDetails)
    ]);
}